import { render, staticRenderFns } from "./einstellungen-start.vue?vue&type=template&id=bb558500&"
import script from "./einstellungen-start.vue?vue&type=script&lang=js&"
export * from "./einstellungen-start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports